import { getLang } from './i18n';

const RELOAD_KEY = 'wayfarer.recovery-reload';
const COOLDOWN_MS = 5 * 60_000;

/** Checkpoint before restarting; never loop if the GPU or browser stays broken. */
export function restartDrive(automatic = false): boolean {
  if (automatic) {
    try {
      const previous = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
      if (Date.now() - previous < COOLDOWN_MS) return false;
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      return false;
    }
  }
  window.dispatchEvent(new Event('wayfarer:checkpoint'));
  location.reload();
  return true;
}

export function installDriveRecovery(parent: HTMLElement): void {
  const button = document.createElement('button');
  button.className = 'drive-restart';
  button.type = 'button';
  button.textContent = getLang() === 'th' ? 'เริ่มใหม่' : 'Restart';
  button.setAttribute('aria-label', getLang() === 'th' ? 'เริ่มแอปใหม่และเดินทางต่อ' : 'Restart app and resume trip');
  button.addEventListener('click', () => restartDrive());
  parent.append(button);
}
